<template>
  <div>
    <div>
      <p class="sheet-title">{{ $t('price_list_title') }}</p>

      <div id="productPriceList__sheetContent" class="sheet-content">
        <div v-for="priceInfo in priceList" :key="priceInfo.upgrade_id" class="wd-flex wd-justify-between">
          <p class="priceName">{{ priceInfo.name }}</p>
          <p class="pricePrice">{{ $t('price_up', [`${symbolCode} ${priceInfo.total_price}`]) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductPriceList',
  components: {},
  props: {
    priceList: { type: Array, default: () => [] },
    symbolCode: { type: String, default: '' },
  },
  computed: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.priceName {
  margin: 11px 12px 11px 0;
}
.pricePrice {
  display: flex;
  margin-top: 11px;
  margin-bottom: 0;
  min-width: fit-content;
}

@include xxs {
  #productPriceList__sheetContent {
    margin-top: 0px;
    margin-bottom: 6px;
  }
}
</style>
